/**
 * Created by Z179603 on 8/23/2016.
 */
'use strict';

angular.module('cvsApp')
    .factory("commonFunctionality",['loggerService','userSession','doPaymentService','$state','webAnalytics','help',
        function(loggerService,UserSession,doPaymentService,$state,webAnalytics,help){

        var log = loggerService('paymentCollection-commonFunctionality');
        return{
            disableAutoPay:function(){
                var activeMop=_.filter(UserSession.accountData.paymentMethods, {"activeFlag": "ACTIVE"});
                var formData=angular.copy(activeMop[0]);
                formData.transactionMode = "NONE";
                formData.createdBy = "DIGITAL WEB";
                formData.paymentCurrency = "";
                formData.paymentIndicator = "FULL";

                formData.componentID=cvsUtility.componentName()?cvsUtility.componentName():"OLP";//cvsUtility.queryMap.FromQuickRegistration?"QR":"OLP";
                formData.fastIndicator="Yes";
                if(formData.payment.method=="CHECK"){
                    formData.achAcceptanceInd="true"
                }else{
                    formData.achAcceptanceInd="";
                }
                formData.payment.amount="0";
                formData.payment.type="RECURRING";
                formData.activeInd="INACTIVE";
                doPaymentService.doPayment(formData, function(response){
                    if(response && response.apiResponse && !response.apiResponse.showError){

                        var utagObj={
                            spx_payment_method: formData.payment.type+"-"+formData.payment.method,
                            spx_account_balance: formData.payment.amount,
                            spx_payment_amount: formData.payment.amount//TODO
                        };
                        webAnalytics.webTrendsUtag("OBJ",utagObj,undefined,"paymentConfirmation");
                        var _registered=true;
                        if(cvsUtility.queryMap.tokenId){
                            _registered=true;
                        } else{
                            _registered=false;
                        }
                        if(_registered){
                            UserSession.init(_registered);
                        }else{
                            UserSession.init(_registered,'guest',UserSession.guestTokenID);
                        }
                    }else{
                        help.broadCast("SERVER-ERROR");
                    }
                });

            },
            renewACH:function(){
                var activemop=_.filter(UserSession.accountData.paymentMethods, {"primaryMethod": "true"});
                var formData=angular.copy(activemop[0]);
                formData.transactionMode = "NONE";
                formData.payment.type= "RECURRING";
                formData.createdBy = "DIGITAL WEB";
                formData.paymentCurrency = "";
                formData.paymentIndicator = "FULL";

                formData.componentID=cvsUtility.componentName()?cvsUtility.componentName():"OLP";//cvsUtility.queryMap.FromQuickRegistration?"QR":"OLP";
                formData.fastIndicator="Yes";
                if(formData.payment.method=="CHECK"){
                    formData.achAcceptanceInd="true"
                }else{
                    formData.achAcceptanceInd="";
                }

                doPaymentService.doPayment(formData, function(response){
                    if(response && response.apiResponse && !response.apiResponse.showError){

                        var utagObj={
                            spx_payment_method: formData.payment.type+"-"+formData.payment.method,
                            spx_account_balance: formData.payment.amount,
                            spx_payment_amount: formData.payment.amount//TODO
                        };
                        webAnalytics.webTrendsUtag("OBJ",utagObj,undefined,"paymentConfirmation");
                        var _registered=true;
                        if(cvsUtility.queryMap.tokenId){
                            _registered=true;
                        } else{
                            _registered=false;
                        }
                        if(_registered){
                            UserSession.init(_registered);
                        }else{
                            UserSession.init(_registered,'guest',UserSession.guestTokenID);
                        }
                    }else{
                        help.broadCast("SERVER-ERROR");
                    }
                    /*$scope.SERVER_ERROR = true;*/
                });
            }
        }

    }]);

